export default defineAppConfig({
  customer: {
    projectName: "Win.Casino",
    projectEmail: "info@win.casino"
  }
})
